export default __webpack_public_path__ + "static/media/logo.4a1601a8.png";